import Proposta from 'models/Proposta';
import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import api from 'services/api';

interface Params {
  codigo?: string;
  versao?: string;
}

export default function RouterProposta(): JSX.Element {
  const params = useParams<Params>();
  const history = useHistory();
  const codigoParam = params?.codigo;
  const versaoParam = params?.versao;

  async function functionNavigateToProposta() {
    try {
      if (codigoParam && versaoParam) {
        const propostaVersaoId = Number(versaoParam);
        const propostaId = Number(codigoParam);

        const response = await api.get(
          `/proposta/${propostaId}/versao/${propostaVersaoId}`,
        );

        const retorno = response.data;

        const {
          proposta,
          propostaVersao,
        }: {
          proposta: any;
          propostaVersao: any;
        } = retorno;

        if (
          proposta &&
          propostaVersao &&
          Object.keys(proposta).length !== 0 &&
          Object.keys(propostaVersao).length !== 0
        ) {
          history.push({
            pathname: '/admin/proposta',
            state: { proposta, propostaVersao, acessarAprovacao: true },
          });
        }
      }
    } finally {
      //
    }
  }

  useEffect(() => {
    if (codigoParam && versaoParam) {
      functionNavigateToProposta();
    }
  }, [codigoParam, versaoParam]);

  return <></>;
}
